<template>
    <div class="cbg-content">
        <div class="cbg-top">
            <div v-for="(item, a) in validDefaultData" :key="a">
                <div class="contentCenterTitle">{{ item.value1 }}</div>
                <div class="dl">
                    <div class="centerNum" v-for="(item, i) in +item.value3" :key="i"><span>{{ getNum(a, i) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bar_bg"></div>
        <div class="lt-left"></div>
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: "template.scope119",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '数据统计', value2: '11566', value3: '6', value4: '系列一', value5: '20', value6: '外圈1' },
                { value1: '数据统计', value2: '42', value3: '3', value4: '系列一', value5: '50', value6: '外圈2', },
                { value1: '数据统计', value2: '156', value3: '3', value4: '系列一', value5: '22', value6: '外圈3', },
                { value1: '数据统计', value2: '432', value3: '3', value4: '系列一', value5: '33', value6: '外圈4', },
                { value1: '', value2: '', value3: '', value4: '系列一', value5: '35', value6: '外圈5', }
            ],
            valueMap: [
                { name: '概览名称', key: "value1" },
                { name: '概览数值', key: "value2" },
                { name: '概览位数', key: "value3" },
                { name: "雷达图例", key: "value4" },
                { name: '对应数值', key: 'value5' },
                { name: '对应外圈', key: 'value6' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            numTotals: [], // 动态存储 numtotal 的数组
            timers: [], // 动态存储定时器的数组
            paddedNumCache: [], // 存储补零后的字符串结果
            validDefaultData: [], // 存储符合位数限制的数据
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata() {
            this.setdata()
            this.DrawEcharts();
        }
    },
    methods: {
        ...methods,
        setdata() {
            let totalDigits = 0;
            let validIndex = 0;
            // 找出符合 18 位限制的数据项
            for (let i = 0; i < this.defaultdata.length; i++) {
                const currentDigits = +this.defaultdata[i].value3;
                if (totalDigits + currentDigits <= 18) {
                    totalDigits += currentDigits;
                    validIndex = i;
                } else {
                    break;
                }
            }
            // 截取符合条件的数据项
            this.validDefaultData = this.defaultdata.slice(0, validIndex + 1);

            if (this.validDefaultData && this.validDefaultData.length) {
                this.numTotals = this.validDefaultData.map(() => 0);
                this.paddedNumCache = this.validDefaultData.map((item) => {
                    let numStr = item.value2.toString();
                    // 如果 value2 的位数超过 value3，只取前 value3 位
                    if (numStr.length > +item.value3) {
                        numStr = numStr.slice(0, +item.value3);
                    }
                    return this.numreduce(numStr, +item.value3);
                }); // 初始化缓存数组，处理后根据 value2 和 value3 补零
                this.validDefaultData.forEach((item, i) => {
                    item.value = +item.value2 || 0;
                });
                this.validDefaultData = this.validDefaultData.filter(item => item.value3 && +item.value3 > 0)
            }
        },

        numreduce(num, len) {
            let start = "";
            let numend = num.toString();
            if (numend.length < len) {
                for (let i = 0; i < len - numend.length; i++) {
                    start = start + "0";
                }
            }
            return start + numend;
        },
        indexSumnew(index) {
            if (+this.validDefaultData[index].value !== +this.numTotals[index]) {
                let num = this.numreduce(
                    +this.validDefaultData[index].value,
                    +this.validDefaultData[index].value3
                ).split("");
                let strnum = this.numreduce(
                    +this.numTotals[index],
                    +this.validDefaultData[index].value3
                ).split("");
                strnum.forEach((del, a) => {
                    if (+del < +num[a]) {
                        strnum[a] = +del + 1;
                    }
                });
                this.numTotals[index] = strnum.join("");
                this.paddedNumCache[index] = this.numreduce(
                    this.numTotals[index],
                    +this.validDefaultData[index].value3
                ); // 更新缓存
            } else {
                clearInterval(this.timers[index]);
                this.timers[index] = null;
                setTimeout(() => {
                    this.numTotals[index] = 0;
                    this.paddedNumCache[index] = "0".repeat(
                        +this.validDefaultData[index].value3
                    ); // 重置缓存
                    this.timers[index] = setInterval(() => {
                        this.indexSumnew(index);
                    }, 300);
                }, 5000);
            }
        },
        startTimers() {
            this.timers.forEach((timer) => {
                if (timer) {
                    clearInterval(timer);
                }
            });
            this.timers = [];
            this.validDefaultData.forEach((_, index) => {
                this.timers[index] = setInterval(() => {
                    this.indexSumnew(index);
                }, 300);
            });
        },
        getNum(a, i) {
            // 检查索引是否越界
            if (a >= this.paddedNumCache.length) {
                return "0";
            }
            // 从缓存中获取补零后的字符串
            const paddedNum = this.paddedNumCache[a];
            return paddedNum[i] || "0";
        },
        
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.cmain1);
            let rader = []
            let xdata = []
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            rader = [...new Set(vdata.map(item => item.value6))]
            xdata = [...new Set(vdata.map(item => item.value4))]
            let raderdata = rader.map((item, i) => {
                let vlist = this.defaultdata.filter(del => del.value6 == item)
                let max = Math.max(...vlist.map(item => +item.value5)) * 1.05 + 10
                let newitem = {
                    name: item,
                    max: max
                }
                return newitem
            })
            let serdata = xdata.map(item => {
                let nitem = {
                    name: item,
                    value: []
                }
                raderdata.forEach(del => {
                    let vitem = this.defaultdata.find(arr => (arr.value4 == item && arr.value6 == del.name))
                    let ndata = vitem ? +vitem.value5 : 0
                    nitem.value.push(ndata)
                })
                return nitem
            })
            let colormap = ['#0182FC', '#01E4E7', '#1B4DEA', '#B1E4FF', '#00D388', '#E4F5FF']
            const Toption = {
                legend: {
                    show: true,
                    data: serdata.map((item, i) => {
                        return {
                            name: item.name,
                            itemStyle: {
                                color: colormap[i]
                            }
                        }
                    }),
                    orient: 'vertical',
                    right: '25%',
                    top: 'center',
                    textStyle: {
                        color: '#EAE9EB',
                        fontSize: "16",
                    },
                    itemGap: 16,
                    itemWidth: 16,
                    itemHeight: 6,
                    height: 220,
                    align: 'left',
                },
                color: colormap,
                radar: {
                    center: ['30%', '60%'],
                    indicator: raderdata,
                    radius: '80%',
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#374E6F'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#374E6F'
                        }
                    },
                    axisName: {
                        fontSize: "16",
                        color: '#fff'
                    },
                },
                series: [
                    {
                        type: 'radar',
                        data: serdata.map((item,i) => {
                            let newitem = {
                                name: item.name,
                                value: item.value,
                                itemStyle: {
                                    color: '#E8F3FE'
                                },
                                areaStyle: {
                                    color: new echarts.graphic.RadialGradient(.5, .5, .5, [
                                        {
                                            color: 'rgba(0, 0, 0, .1)',
                                            offset: 0
                                        },
                                        {
                                            color: colormap[i],
                                            offset: 1
                                        }
                                    ])
                                }
                            }
                            return newitem
                        }),
                    }
                ]
            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.setdata()
        this.DrawEcharts();
    }
};
</script>

<style scoped lang="scss">
.cbg-content {
    height: 600px;
    pointer-events: auto;

    .cbg-top {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        column-gap: 28px;
    }

    .contentCenterTitle {
        font-size: 16px;
        color: #fff;
    }

    .centerNum {
        width: 41px;
        width: 41px;
        height: 54px;
        background: url(../../assets/template/num-bg.png) no-repeat;
        background-size: 100%;
        margin: 4px 6px 0 0;
        font-family: "lcdd";
        font-size: 45px;
        color: #fff;
        line-height: 50px;
        text-align: left;

        span {
            font-family: YeJinShuZi;
            padding-left: 7px;
        }
    }

    .dl {
        display: flex
    }

    .bar_bg {
        width: 1117px;
        height: 180px;
        background: url("../../assets/temimg11/bar_bg.png") no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: calc(50% - 558.5px);
    }

    .lt-left {
        width: 413px;
        height: 413px;
        position: absolute;
        left: calc(50% - 377px);
        top: calc(50% - 169px);
        box-sizing: border-box;
        background: url("../../assets/temimg11/leida_cen.png") no-repeat;
        background-size: 100%;
    }

    .cmain {
        width: 95%;
        height: calc(100% - 200px);
        margin: 0 auto;
    }

    .center_text {
        position: absolute;
        top: 54%;
        left: 29%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 41px;
        color: #ffffff;
        line-height: 48px;

        span {
            max-width: 140px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 21px;
            color: #ffffff;
            line-height: 48px;
        }
    }
}
</style>